module.exports = __webpack_public_path__ + "plat/static/img/user.4f339cbe.png";